<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p class="firstInSection">For Jacob</p>
<p><em>corban redux</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?423f8439